import React, { useState, useEffect } from 'react';
import {
	Modal,
	ModalHeader,
	ModalBody,
	Form,
	FormGroup,
	Label,
	Input,
} from 'reactstrap';
import axios from 'axios';
import Message from '../utils/Message';

const UpdateDbEditTable = ({
	toggle,
	modal,
	currentReportRowData,
	projectId,
	table,
	accessToken,
	database,
	errorMsg,
	setErrorMsg,
	closeModal,
}) => {
	const [editFields, setEditFields] = useState([]);

	useEffect(() => {
		if (currentReportRowData && database) {
			let acc = { ...currentReportRowData };
			// set data to edit from client data
			const data = database.field2Edit.map((e) => {
				// split the dot query
				const str = e.field && e.field.split('.');
				const length1 = str.length === 1 ? acc[str[0]] : '';
				const length2 =
					str.length === 2 && acc[str[0]] ? acc[str[0]][str[1]] : '';
				const length3 =
					str.length === 3 && acc[str[0]][str[1]]
						? acc[str[0]][str[1]][str[2]]
						: '';
				const length4 =
					str.length === 4 && data[str[0]][str[1]][str[2]]
						? data[str[0]][str[1]][str[2]][str[3]]
						: '';
				let newD = { ...e };
				newD.value =
					str.length === 1
						? length1
						: str.length === 2
						? length2
						: str.length === 3
						? length3
						: length4;
				return newD;
			});
			setEditFields(data);
		}
	}, [currentReportRowData, database]);

	// console.log('currentReportRowData', currentReportRowData);

	const updateData = (e, index) => {
		e.preventDefault();
		let acc = [...editFields];
		acc[index].value = e.target.value;
		setEditFields(acc);
	};

	function updateCurrentData(e) {
		e.preventDefault();
		let acc = [...editFields];

		let upData = {}; // updating data
		acc.forEach((each) => {
			upData[each.field] = each.value;
		});

		let newData = {};
		newData.id = currentReportRowData._id;
		newData.token = accessToken;
		newData.update = upData;
		newData.tableName = table;

		axios
			.post(database.editEndpoint, newData)
			.then((data) => {
				// setUpdated(true);
				closeModal();
			})
			.catch((err) => setErrorMsg(err.response));
	}

	// console.log('errorMsg', errorMsg);
	// console.log('currentReportRowData', currentReportRowData);
	return (
		<div>
			<Modal isOpen={modal} toggle={toggle}>
				<ModalHeader style={{ border: 'none' }} toggle={toggle}>
					Update Database
				</ModalHeader>
				<ModalBody>
					{errorMsg && (
						<Message color='danger' fullWidth='true'>
							{errorMsg}
						</Message>
					)}
					<Form style={{ padding: '1rem 0 0 0' }}>
						<FormGroup>
							{editFields.length &&
								editFields.map((each, idx) => {
									return (
										<div key={idx}>
											{each.type !== 'dropdown' ? (
												<div className='mt-3'>
													<Label
														for={each.label}
														style={{ marginLeft: '1rem' }}>
														{each.label}
													</Label>
													<Input
														type={each.type}
														name={each.field}
														value={each.value}
														onChange={(e) => updateData(e, idx)}
													/>
												</div>
											) : (
												<FormGroup className='mt-3'>
													<Label
														for={each.label}
														style={{ marginLeft: '1rem' }}>
														{each.label}
													</Label>
													<Input
														type='select'
														name='dropdown'
														className='new-input'
														value={each.value}
														onChange={(e) => updateData(e, idx)}>
														<option value=''>Select</option>
														{each.dropdown.map((drop, i) => {
															return (
																<option value={drop} key={i}>
																	{drop}
																</option>
															);
														})}
													</Input>
												</FormGroup>
											)}
										</div>
									);
								})}
						</FormGroup>
						<div>
							<button
								onClick={(e) => updateCurrentData(e)}
								className='btn btn-primary'>
								Save
							</button>
						</div>
					</Form>
				</ModalBody>
			</Modal>
		</div>
	);
};

export default UpdateDbEditTable;
